import React from 'react';
import Typography from 'apollo-react/components/Typography';
import AlertTriangle from 'apollo-react-icons/AlertTriangle';
import ThumbsUp from 'apollo-react-icons/ThumbsUpFilled';
import FileDocuments from 'apollo-react-icons/FileDocuments';
import Spinner from 'apollo-react-icons/Refresh';
import styles from './SubFormTab.module.css';

const SubFormTab = React.memo(
  ({ form, isActive, onClick, isLoading, prevComments, errors }) => {
    // for custom / profile menu forms, use hasComments on the form row; for workflow
    // subforms fall back to prevComments (subForm_id or profile_section_key).
    const hasComments =
      form.hasComments !== undefined
        ? form.hasComments
        : prevComments?.some(
            (comment) =>
              comment.subForm_id === form.id ||
              (form.isHcpProfileMenu &&
                String(comment.profile_section_key) === String(form.id))
          );

    const tabClass = isActive
      ? styles.activeTab
      : form.approved
        ? styles.approvedTab
        : hasComments
          ? styles.commentTab
          : '';

    const renderIcon = () => {
      if (isLoading) {
        return (
          <Spinner className={`${styles.thumbsUpIcon} ${styles.loadingIcon}`} />
        );
      }
      if (form.approved) {
        return <ThumbsUp className={styles.thumbsUpIcon} />;
      }
      if (hasComments) {
        return <FileDocuments className={styles.thumbsUpIcon} />;
      }

      if (errors?.subforms?.[form.id]?.hasErrors) {
        return <AlertTriangle className={styles.thumbsUpIcon} />;
      }

      if (
        errors?.hcpLicensesList?.hasErrors &&
        form.id === 'custom_hcp_licenses_list'
      ) {
        return <AlertTriangle className={styles.thumbsUpIcon} />;
      }
    };

    return (
      <div
        onClick={() => onClick(form.id)}
        className={`${styles.verticalTabItemContainer} ${tabClass}`}
      >
        <Typography className={styles.verticalTabItemText}>
          {form.name}
        </Typography>
        {renderIcon()}
      </div>
    );
  }
);

export default SubFormTab;
